import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { MiniDrawerV4Props } from './MiniDrawer.props';
import { MainMenuItem } from '..';
import { getIconForSection } from '../DrawerContent/iconMap';

const iconWrapperSx = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  py: '8px',
  borderLeft: '3px solid transparent',
  cursor: 'pointer',
  color: '#cbd5e1',
  transition: 'background .15s',
  '&:hover': { bgcolor: '#0f172a', color: '#fff' },
} as const;

const activeSx = {
  bgcolor: 'v4.sidebarActive',
  borderLeftColor: 'v4.accent',
  color: '#fff',
} as const;

const iconSize = { fontSize: 20 } as const;

export const MiniDrawer: React.FC<MiniDrawerV4Props> = ({ menuData }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (url: string) =>
    url !== '' && location.pathname === url;

  const isSectionActive = (item: MainMenuItem): boolean => {
    if (item.url && isActive(item.url)) return true;
    if (item.subMenuItems) {
      return item.subMenuItems.some(
        (sub) =>
          isActive(sub.url) ||
          (sub.subMenuItems?.some((child) => isActive(child.url)) ?? false),
      );
    }
    return false;
  };

  const getFirstUrl = (item: MainMenuItem): string => {
    if (item.url) return item.url;
    if (item.subMenuItems?.[0]) {
      const sub = item.subMenuItems[0];
      if (sub.url) return sub.url;
      if (sub.subMenuItems?.[0]?.url) return sub.subMenuItems[0].url;
    }
    return '';
  };

  return (
    <Box component="nav" aria-label="Mini navigation">
      {menuData.map((item) => {
        const Icon = getIconForSection(item.name);
        const active = isSectionActive(item);
        const url = getFirstUrl(item);

        return (
          <Tooltip key={item.id} title={item.name} placement="right" arrow>
            <Box
              onClick={() => url && navigate(url)}
              sx={{ ...iconWrapperSx, ...(active ? activeSx : {}) }}
              role="link"
              tabIndex={0}
              onKeyDown={(e) =>
                e.key === 'Enter' && url && navigate(url)
              }
              aria-label={item.name}
            >
              <Icon sx={iconSize} />
            </Box>
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default MiniDrawer;
